import React from 'react';
import routes from 'lib/routes';
import AppContainer from 'stores/AppContainer';
import { initCsrfCookie, api } from 'lib/ajax';
import logout from 'lib/logout';
import { parseDate } from 'lib/helpers';
// LM: 2021-06-02 09:56:26 [Mixpanel Integration]
import mixpanel from 'mixpanel-browser';

function saveUtmSourceAndMixpanelIdIfExists() {
    const qs = window.location.search;
    const utmSourceRegExp = /utm_source=([^&]*)/ig;
    const mixpanelIdRegExp = /mixpanel_id=([^&]*)/ig;
    if (qs.trim() !== '') {
        const utmSourceMatches = qs.match(utmSourceRegExp);
        if (utmSourceMatches !== null && utmSourceMatches.length) {
            const p = utmSourceMatches[0].split('=');
            sessionStorage.setItem('utmSource', decodeURIComponent(p[1]));
        }
        const mixpanelIdMatches = qs.match(mixpanelIdRegExp);
        if (mixpanelIdMatches !== null && mixpanelIdMatches.length) {
            const mp = mixpanelIdMatches[0].split('=');
            console.log('Saving mixpanel id from wp: ' + decodeURIComponent(mp[1]));
            sessionStorage.setItem('mixpanelIden', decodeURIComponent(mp[1]));
        }
    }
}


const handshakePromise = React.lazy(() => {
    return new Promise((resolve, reject) => {
        (async () => {
            await initCsrfCookie();
            try {
                const res = await api.httpGet(routes.api.handshake, {
                    params: {
                        // Send clients date details
                        'clientToday': parseDate(new Date()).dbFriendly
                    }
                });
                const { user, egtkn } = res.data;
                if (user) { // if user is authenticated
                    sessionStorage.removeItem('user');
                    sessionStorage.setItem('user', JSON.stringify(user));
                    localStorage.setItem('userAuthState', (new Date()).getTime());
                }
                else {
                    // Clears all data in sessionStorage, localStorage, and other third party stored data.
                    logout.clear();
                }
                if (egtkn) { // save the api token to be used for all api calls.
                    api.setToken(egtkn);
                }
                sessionStorage.removeItem('apiHandshakeData');
                sessionStorage.setItem('apiHandshakeData', JSON.stringify(res.data));
                // LM: 2021-06-04 09:26:34 [Get utm_source and mixpanel_id values if present in the query string]
                saveUtmSourceAndMixpanelIdIfExists();
                window.mixpanelIsLoaded = new Promise((res, rej) => {
                    // LM: 2021-06-02 10:14:39 [Set up mixpanel tracking]
                    mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
                        loaded: async (mixpanel) => {
                            if (user) {
                                if (user['mixpanel_id']) {
                                    mixpanel.identify(user['mixpanel_id']);
                                    sessionStorage.setItem('mixpanelIden', user['mixpanel_id']);
                                    mixpanel.people.set({
                                        '$name': user.fullname,
                                        '$email': user.email,
                                        '$referring_domain': window.location.href
                                    });
                                    mixpanel.register({
                                        'Name': user.fullname,
                                        'Email': user.email
                                    });
                                    res(mixpanel);
                                }
                                else {
                                    // For existing users that don't have a mixpanel id yet
                                    mixpanel.reset();
                                    const mixpanelId = mixpanel.get_distinct_id();
                                    await api.httpPost(routes.api.setMixpanelId, { 'mixpanel_id': mixpanelId });
                                    mixpanel.alias(user.email, mixpanelId);
                                    sessionStorage.setItem('mixpanelIden', mixpanelId);
                                    mixpanel.people.set({
                                        '$name': user.fullname,
                                        '$email': user.email,
                                        '$referring_domain': window.location.href
                                    });
                                    mixpanel.register({
                                        'Name': user.fullname,
                                        'Email': user.email
                                    });
                                    res(mixpanel);
                                }
                            }
                            else { // User is not logged in
                                mixpanel.reset();
                                const mixpanelId = (() => {
                                    if (sessionStorage.getItem('mixpanelIden')) {
                                        console.log('Using mixpanel id: ' + sessionStorage.getItem('mixpanelIden'));
                                        mixpanel.identify(sessionStorage.getItem('mixpanelIden'));
                                        return sessionStorage.getItem('mixpanelIden');
                                    }
                                    return mixpanel.get_distinct_id();
                                })();
                                sessionStorage.setItem('mixpanelIden', mixpanelId);
                                res(mixpanel);
                            }
                        }
                    });
                });
                resolve({
                    default: (props) => (
                        <AppContainer.Provider>{props.children}</AppContainer.Provider>
                    )
                });
            }
            catch (err) {
                console.error(err);
                reject(err);
            }
        })();
    });
});

export default handshakePromise;